module.exports = __webpack_public_path__ + "img/01_img_login.bcc4d044.png";